import type en from "../en/auth";
import type { Messages } from "../../types";

const fr: Messages<typeof en> = {
  metaLogin: "Connexion",
  metaRegister: "Créer votre compte",
  metaForgot: "Réinitialiser votre mot de passe",
  metaReset: "Choisir un nouveau mot de passe",
  metaVerify: "Vérifier votre adresse e-mail",
  loginTitle: "Bon retour parmi nous",
  loginSubtitle: "Connectez-vous pour gérer vos boutiques.",
  passwordChanged: "Votre mot de passe a été modifié. Connectez-vous avec votre nouveau mot de passe.",
  newToStorelancer: "Nouveau sur Storelancer ?",
  createAnAccount: "Créer un compte",
  registerTitle: "Créer votre compte",
  registerSubtitle: "Commencez avec le forfait Starter gratuit. Aucune carte bancaire requise.",
  haveAccount: "Vous avez déjà un compte ?",
  signIn: "Se connecter",
  signingIn: "Connexion…",
  forgotTitle: "Réinitialiser votre mot de passe",
  forgotSubtitle: "Saisissez l’adresse e-mail de votre compte et nous vous enverrons un lien de réinitialisation.",
  backToSignIn: "Retour à la connexion",
  resetTitle: "Choisir un nouveau mot de passe",
  resetLinkIncomplete: "Ce lien de réinitialisation est incomplet.",
  requestNewOne: "Demander un nouveau lien",
  verifyTitle: "Vérification de l’adresse e-mail",
  verifyLinkIncomplete: "Ce lien de vérification est incomplet.",
  verifyRequestNew: "Vous pouvez demander un nouveau lien depuis les paramètres de votre compte.",
  verifySuccess: "Votre adresse e-mail est vérifiée.",
  goToDashboard: "Accéder au tableau de bord",
  fieldEmail: "E-mail",
  fieldPassword: "Mot de passe",
  fieldName: "Votre nom",
  fieldNewPassword: "Nouveau mot de passe",
  fieldConfirmPassword: "Confirmer le mot de passe",
  forgotLink: "Mot de passe oublié ?",
  passwordHint: "Au moins 10 caractères, dont une lettre et un chiffre.",
  termsAgree: "J’accepte les {terms} et la {privacy}",
  termsLink: "conditions d’utilisation",
  privacyLink: "politique de confidentialité",
  createAccount: "Créer le compte",
  creatingAccount: "Création du compte…",
  sendResetLink: "Envoyer le lien",
  sending: "Envoi…",
  setNewPassword: "Enregistrer le nouveau mot de passe",
  acceptTerms: "Veuillez accepter les conditions d’utilisation.",
  required: "Obligatoire",
  resetSent: "Si un compte existe pour cette adresse, nous avons envoyé un lien de réinitialisation. Il expire dans 1 heure.",
  passwordsDontMatch: "Les mots de passe ne correspondent pas.",
};

export default fr;
